// components/notifications/common/ActionsRow.jsx
import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ActionsRowContainer } from '../helpers/notificationUtils';

/**
 * Action shape:
 * {
 *   key?: string,                // optional stable key
 *   label: string,
 *   color?: 'primary'|'error'|'success'|'secondary'|'inherit',
 *   primary?: boolean,           // renders as 'contained' if true else 'outlined'
 *   disabled?: boolean,
 *   loading?: boolean,           // show spinner
 *   href?: string,               // navigate via onOpenHref if present
 *   action?: string,             // identifier (e.g., 'accept_invitation')
 *   onClick?: () => void,        // optional direct handler (takes precedence over onAction)
 *   meta?: any,                  // will be sent back via onAction
 * }
 */

export default function ActionsRow({
  actions = [],
  onAction,      // (actionObj) => void
  onOpenHref,   // (href) => void
}) {
  if (!actions.length) return null;

  return (
    <ActionsRowContainer>
      {actions.map((a, i) => {
        const key = a.key ?? `${a.label}-${i}`;
        const variant = a.primary ? 'contained' : 'outlined';
        const color = a.color || 'primary';
        const disabled = !!a.disabled || !!a.loading;

        const handleClick = () => {
          if (a.onClick) return a.onClick();
          if (a.href) return onOpenHref?.(a.href);
          return onAction?.(a);
        };

        return (
          <Button
            key={key}
            size="small"
            variant={variant}
            color={color}
            onClick={handleClick}
            disabled={disabled}
            endIcon={a.href && a.primary ? <OpenInNewIcon fontSize="small" /> : undefined}
            sx={{ borderRadius: 10, fontWeight: a.primary ? 700 : 500, minWidth: 96 }}
          >
            {a.loading ? <CircularProgress size={16} color="inherit" /> : a.label}
          </Button>
        );
      })}
    </ActionsRowContainer>
  );
}
